import { useCallback, useEffect, useState } from 'react'
import DesktopFilter from '@/components/organisms/filter/desktopFilter'
import {
  Desktop,
  MediaContextProvider,
  Mobile,
  Tablet
} from '@/components/atoms/media'
import TabletMobileFilterRedesign, {
  TabletMobileFilterProps
} from './filterMobile'
import { SlugPath } from 'types/slugPath'
import { Box } from '@/components/atoms/Grid'
import { Category } from '@/network/graphql.g'
import {
  useActiveFiltersCount,
  useFilter
} from '@/providers/filterProvider/filtersProvider'
import Head from 'next/head'

type FilterProps = {
  slugPath?: SlugPath
  subcategories?: Category[]
  showInStorage?: boolean
  showInSale?: boolean
  showNews?: boolean
  isInSaleCampaign?: boolean
  isParfumCampaign?: boolean
  isMain?: Category
} & Rest

const Filter = ({
  subcategories,
  slugPath,
  showInStorage = true,
  showInSale = true,
  showNews = true,
  isInSaleCampaign,
  isParfumCampaign,
  isMain,
  ...rest
}: FilterProps): JSX.Element => {
  const { filter } = useFilter()
  const tabletMobileProps = useCallback(
    (): TabletMobileFilterProps => ({
      subcategories,
      slugPath,
      filter,
      showInStorage,
      showInSale: showInSale && !isInSaleCampaign,
      showNews,
      setIndex,
      setFollow,
      isParfumCampaign,
      ...rest
    }),
    [slugPath, filter]
  )
  const { activeFilters } = useFilter()
  const activeFiltersCount = useActiveFiltersCount()
  const [index, setIndex] = useState<string>('index')
  const [follow, setFollow] = useState<string>('follow')

  useEffect(() => {
    const metaContentCondition =
      activeFiltersCount >= 4 || activeFilters.price.query
    const indexValue = metaContentCondition ? 'noindex' : 'index'
    const followValue = metaContentCondition ? 'nofollow' : 'follow'
    setIndex(indexValue)
    setFollow(followValue)
  }, [activeFiltersCount, activeFilters])

  return (
    <Box textAlign="left" mb={isMain && 15}>
      <Head>
        <meta name="robots" content={`${index}, ${follow}`} />
      </Head>
      <MediaContextProvider>
        <Desktop>
          <DesktopFilter
            filter={filter}
            showInStorage={showInStorage}
            showInSale={showInSale && !isInSaleCampaign}
            isParfumCampaign={isParfumCampaign}
            {...rest}
          />
        </Desktop>
        <Tablet>
          <TabletMobileFilterRedesign
            isTablet={true}
            {...tabletMobileProps()}
          />
        </Tablet>
        <Mobile>
          <TabletMobileFilterRedesign
            isTablet={false}
            {...tabletMobileProps()}
          />
        </Mobile>
      </MediaContextProvider>
    </Box>
  )
}

export default Filter
